import * as action from './loaderAction'
import { default as actionType } from './loaderActionType'
import { default as reducer } from './loaderReducer'

export const LOADER = {
  action,
  actionType,
  reducer
}
